import type { GetDocumentFileAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import { GetDocumentFileAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetDocumentFileAuditByIdArgs = {
  id: string;
};

export const useGetDocumentFileAuditById = createQueryHook<
  UseGetDocumentFileAuditByIdArgs,
  GetDocumentFileAuditByIdResponseRow[],
  AuditLogQueryResult<
    'document_file_audit',
    GetDocumentFileAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getDocumentFileAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ document_file_audit: data }),
  graphqlDocument: GetDocumentFileAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
